const state = {
  usuario: {},
};

export default state;
